__turbopack_context__.v({
  "container": "FeaturesSection-module-scss-module__xy5XQa__container",
  "featureWrapper": "FeaturesSection-module-scss-module__xy5XQa__featureWrapper",
  "root": "FeaturesSection-module-scss-module__xy5XQa__root",
  "visible": "FeaturesSection-module-scss-module__xy5XQa__visible",
  "wrapper": "FeaturesSection-module-scss-module__xy5XQa__wrapper",
});
